<dcr-segmented-progress
  [attr.low-value]="(scoreScatter.low / (maxAmountScores || 1)) * 100"
  [attr.medium-value]="(scoreScatter.medium / (maxAmountScores || 1)) * 100"
  [attr.high-value]="(scoreScatter.high / (maxAmountScores || 1)) * 100"
  class="w-full"
  data-cy="score-scatter"
></dcr-segmented-progress>
